import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { LineageDatasetsPage } from '@/features/data/lineage/lineage-pages';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Lignage — les jeux de données du locataire (lot L07). La recherche vit dans l'URL (`?search=`). */
export const Route = createFileRoute('/$tenant/lineage/')({
  validateSearch: (search: Record<string, unknown>): { search?: string } => {
    const value = typeof search['search'] === 'string' ? search['search'].trim() : '';
    return value ? { search: value } : {};
  },
  component: LineageRoute,
});

function LineageRoute() {
  const { tenant } = Route.useParams();
  const { search = '' } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { t } = useTranslation();
  return (
    <ConsoleShell tenantId={tenant} activeItem="lineage" crumbs={[{ label: t('nav.items.lineage') }]}>
      <LineageDatasetsPage
        key={search}
        tenantId={tenant}
        search={search}
        onSearch={(next) => void navigate({ search: next ? { search: next } : {}, replace: true })}
      />
    </ConsoleShell>
  );
}
